














import Vue from 'vue'
import { mapGetters } from 'vuex'
import { RawLocation } from 'vue-router'
import { Content } from '@neurotrack/web-shared-components'

export default Vue.extend({
  name: 'FAQCategories',
  components: { Content },
  computed: {
    ...mapGetters('content/faqs', ['categories', 'faqs'])
  },
  created() {
    if (!this.faqs().size) {
      this.$store.dispatch('content/faqs/loadFromContentful')
    }
  },
  methods: {
    to(dest: RawLocation) {
      this.$router.push(dest)
    }
  }
})
